
import { Component, Vue } from "vue-property-decorator";
import ActivityCard from "./activityCard.vue";
import { Settings } from "../../../core/services/configService";
import { CrudService } from "../../../core/services/crudService";
import store from "../../../core/store";
import { DateHelper } from "../../../core/helpers/dateHelper";

@Component({
  components: {
    ActivityCard: ActivityCard as any,
  },
})
export default class ActivitiesBanner extends Vue {
  private readonly pageSize: number = 12;
  registrations: any[] = [];
  registrationsTotal: number = 0;
  activities: any[] = [];
  activitiesTotal: number = 0;

  async mounted() {
    try {
      const [registrationsRes, activitiesRes] = await Promise.all([
        this.fetchActivities("registration"),
        this.fetchActivities("activity"),
      ]);
      this.registrations = registrationsRes.activities;
      this.registrationsTotal = registrationsRes.totalCount;
      this.activities = activitiesRes.activities;
      this.activitiesTotal = activitiesRes.totalCount;
    } catch (e) {
      console.error(e);
    }
  }

  get limitedRegistrations() {
    return this.registrations.slice(0, 4);
  }

  get limitedActivities() {
    return this.activities.slice(0, 4);
  }

  get showRegistrationsLink() {
    return this.registrationsTotal > 4;
  }

  get showActivitiesLink() {
    return this.activitiesTotal > 4;
  }

  private async fetchActivities(type: string) {
    const url = `${Settings.HostName}/api/publicactivities/list?startRow=0&endRow=${this.pageSize}&status=ongoing&type=${type}`;
    const data = await new CrudService().httpGet(url);
    if (!data || !data.ok) {
      console.error("Crash loading activities", type);
      return { activities: [], totalCount: 0 };
    }
    const model = data.model || {};
    const entries = Array.isArray(model.activities) ? model.activities : [];
    return {
      activities: entries.map((entry: any) => entry.activity).filter((activity: any) => !!activity),
      totalCount: model.totalCount || 0,
    };
  }

  formatDate(date: string) {
    const dateObj = DateHelper.toDate(date, DateHelper.systemFormat);
    return DateHelper.formatDate(dateObj, "yyyy-MM-dd");
  }

  getImageProduct(name: string) {
    if (name) {
      return store.state.settings.Uploads + "/" + name;
    }
    return "/img/activity-default.png";
  }
}
